import { Action } from '../actions/types'

const INITIAL_STATE = {
    rid: '',
    progress: 0,
    newImages: {},
    uploadingQueue: [],
    uploadedQueue: [],
    isUploading: false,
    error: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Action.IMAGES_UPLOADING:
            return {
                ...state,
                isUploading: true
            }
        case Action.IMAGES_UPLOAD_COMPLETE:
            return {
                ...state,
                isUploading: false,
                uploadingQueue: [],
                newImages: {
                    ...state.newImages,
                    [action.payload]: []
                }
            }
        case Action.IMAGE_ADD_TO_QUEUE:
            return {
                ...state,
                newImages: {
                    ...state.newImages,
                    [action.payload.currentIndex]: action.payload.pictures
                }
            }
        case Action.IMAGE_UPLOAD_QUEUE:
            return {
                ...state,
                uploadingQueue: [...state.uploadingQueue, {image: action.payload, progress: 0}]
            }
        case Action.IMAGES_UPLOAD_PROGRESS:
            return {
                ...state,
                uploadingQueue: state.uploadingQueue.map((item, index) => {
                    // Find the item with the matching id
                    if(index === action.payload.index) {
                      // Return a new object
                      return {
                        ...item,  // copy the existing item
                        progress: action.payload.progress  // update image upload progress
                      }
                    }
                
                    // Leave every other item unchanged
                    return item
                  }),
            }
        case Action.IMAGE_UPLOADED:
            return {
                ...state,
                uploadedQueue: [...state.uploadedQueue, action.payload]
            }
        case Action.IMAGE_CREATE_QUEUE:
            return {
                ...state,
                newImages: {
                    ...state.newImages,
                    [action.payload.currentIndex]: []
                }
            }
        case Action.IMAGES_RESET:
            return INITIAL_STATE
        default:
            return state
        }
    //return INITIAL_STATE
}